import { fetchCSRFToken } from '@/lib/crm/sugarCrm';
import { isValidEmail } from '@/lib/validation/isValidEmail';

export const CLUB_OPTIONS = [
  'None',
  'Advise Wise Mortgage Club',
  'Air Academy',
  'Air Club',
  'Air Advance',
  'Air Platinum',
  'Air Platinum Academy',
  'Air Advance Academy',
  'Air Elite',
  'Air Select',
  'Brilliant Solutions',
  'Finova Mortgage Club',
  'Legal & General Mortgage Club',
  'Later Life Academy',
  'Paradigm',
  'PERC',
  'PMA',
  'PMS Air Advance',
  'PMS Air Advance Academy',
  'PMS Air Platinum',
  'PMS Air Platinum Academy',
  'PMS Air Elite',
  'Premier ER Club',
  'Premier ER 100 Club',
  'Premier Mortgages Services',
  'Sesame',
  'Simply Biz Air Partnership Advance',
  'Simply Biz Air Partnership Platinum',
  'Simply Biz Air Partnership Advance Academy',
  'Simply Biz Air Partnership Advance Platinum',
  'Simply Biz Air Partnership Select',
  'Simply Biz Air Partnership Elite',
  'SPG',
  'TMA Mortgage Group',
  'Other',
];

export const HEAR_ABOUT_OPTIONS = [
  'Event',
  'Search engine',
  'Social media',
  'Colleague',
  'Email',
  'Phone call',
  'Other',
];

export const NETWORK_OPTIONS = [
  'None',
  'Advance Mortgage Funding',
  'Best Practice IFA Group',
  'ERA',
  'HL Partnerships',
  'JLM Mortgage Network',
  'Mortgage Intelligence Ltd',
  'New Leaf Financial Services',
  'The Open Network Partnership / Openwork Ltd',
  'Personal Touch Financial Services',
  'Primis Advance Mortgage',
  'Primis First Comp',
  'Primis Personal T',
  'Primis Mortgage Network',
  'Quilter Financial Services',
  'Quilter Mortgage Financial Planning',
  'Sesame',
  'St James Place Wealth Management',
  'Stonebridge Mortgage Solutions',
  'Tenet Connect Limited',
  'Tenet Connect Services Limited',
  'Tennet Lime',
  'Tenet TSR',
  'The Later Life Lending Network',
  'The Money Group',
  'The On-line Partnership',
  'The Right Mortgage Limited',
  'The Whitechurch Network Limited',
  'TRM',
  'TRUE POTENTIAL WEALTH Management LLP',
  'Other',
];

export const INITIAL_FORM_DATA = {
  1: {
    firstName: '',
    lastName: '',
    email: '',
    privacyAgreed: false,
  },
  2: {
    fcaId: '',
    fcaLookup: 'ready',
    companyStatus: '',
    name: '',
    phone: '',
    postcode: '',
    al1: '',
    al2: '',
    town: '',
    county: '',
    fcaData: '',
    name2: '',
    phone2: '',
    postcode2: '',
    al12: '',
    al22: '',
    town2: '',
    county2: '',
    mon: '',
    monOther: '',
    councilMember: '',
  },
  3: {
    jobTitle: '',
    mobileNo: '',
    caseUpdates: '',
    commStat: '',
    marketing: '',
    club: '',
    clubOther: '',
    authorised: '',
    account: '',
    accountNumber: '',
    sortCode: '',
    hear: '',
    hearOther: '',
    signature: '',
  },
  step: 1,
  DialogId: 13,
  ownerid: 5,
  cke: 1,
  overwrite: 1,
  PushExternal: 1,
};

export const validateStep1 = (formData) => {
  const errors = {};
  if (!formData.firstName?.trim()) errors.firstName = 'First name is required';
  if (!formData.lastName?.trim()) errors.lastName = 'Last name is required';

  if (!formData.email?.trim()) {
    errors.email = 'Email is required';
  } else if (!isValidEmail(formData.email)) {
    errors.email = 'Invalid email address';
  }

  if (!formData.privacyAgreed) errors.privacyAgreed = 'You must agree to the privacy policy';

  return errors;
};

export const validateStep2 = (formData) => {
  const errors = {};

  // Validate fcaId
  if (!formData.fcaId?.trim()) {
    errors.fcaId = 'You must provide an fca id';
  }

  // Conditionally validate additional fields when fcaData equals '0'
  if (formData.fcaData === '0') {
    if (!formData.name2?.trim()) {
      errors.name2 = 'You must provide a company name';
    }
    if (!formData.phone2?.trim()) {
      errors.phone2 = 'You must provide a company phone number';
    }
    if (!formData.al12?.trim()) {
      errors.al12 = 'You must provide an address line 1';
    }
    if (!formData.town2?.trim()) {
      errors.town2 = 'You must provide a town/city';
    }
    if (!formData.postcode2?.trim()) {
      errors.postcode2 = 'You must provide a postcode';
    }
  }

  if (!formData.councilMember) {
    errors.councilMember = 'Please specify if you are a council member';
  }

  if (!formData.mon || formData.mon === 'Select option') {
    errors.mon = 'Please select an option';
  }

  if (formData.mon === 'Other' && !formData.monOther?.trim()) {
    errors.monOther = 'Please enter an option';
  }

  return errors;
};

export const validateStep3 = (formData) => {
  const errors = {};

  if (!formData.jobTitle?.trim()) {
    errors.jobTitle = 'Job title is required';
  }

  if (!formData.mobileNo?.trim()) {
    errors.mobileNo = 'Mobile number is required';
  }

  if (!formData.club || formData.club === 'Select option') {
    errors.club = 'Please select a club option';
  }

  if (formData.club === 'Other' && !formData.clubOther?.trim()) {
    errors.clubOther = 'Please enter a club name';
  }

  if (!formData.authorised) {
    errors.authorised = 'Please specify if you are directly authorized';
  }

  // Only validate bank account fields if the user is directly authorised
  if (formData.authorised === '1') {
    if (!formData.account?.trim()) {
      errors.account = 'Account name is required';
    }

    if (!formData.accountNumber?.trim()) {
      errors.accountNumber = 'Account number is required';
    }

    if (!formData.sortCode?.trim()) {
      errors.sortCode = 'Sort code is required';
    }
  }

  if (!formData.hear || formData.hear === 'Select option') {
    errors.hear = 'Please select how you heard about us';
  }

  if (formData.hear === 'Other' && !formData.hearOther?.trim()) {
    errors.hearOther = 'Please specify how you heard about us';
  }

  if (!formData.signature?.trim()) {
    errors.signature = 'Digital signature is required';
  }

  return errors;
};

export const validatePhoneNumber = (value, fieldName) => {
  let filteredValue = value.replace(/[^0-9+]/g, '');

  if (filteredValue.startsWith('+44')) {
    if (filteredValue.length > 13) {
      filteredValue = filteredValue.slice(0, 13);
    }
  } else {
    if (filteredValue.length > 11) {
      filteredValue = filteredValue.slice(0, 11);
    }
  }

  return filteredValue;
};

export const validateAccountField = (value, fieldName) => {
  const numericValue = value.replace(/\D/g, '');

  if (fieldName === 'accountNumber' && numericValue.length > 8) {
    return null;
  }

  if (fieldName === 'sortCode' && numericValue.length > 6) {
    return null;
  }

  return numericValue;
};

export const transformToSugarCrmData = (requestData, cpd21Result) => ({
  rurl: '/professionals/register',
  Email: requestData?.email || '',
  FirstName: requestData?.firstName || '',
  LastName: requestData?.lastName || '',
  fca_number_c: requestData?.fcaId || '',
  company_status: requestData?.companyStatus || '',
  Company: requestData?.name || '',
  Phone: requestData?.phone || '',
  PostalCode: requestData?.postcode || '',
  Street: requestData?.al1 || '',
  OtherStreet: requestData?.al2 || '',
  City: requestData?.town || '',
  State: requestData?.county || '',
  Broker_Registration_Details_Correct__c: requestData?.fcaData === '1' ? 'Yes' : 'No',
  updated_firm_name_c: requestData?.name2 || '',
  updated_main_phone_c: requestData?.phone2 || '',
  alt_address_postalcode: requestData?.postcode2 || '',
  alt_address_street: requestData?.al12 || '',
  alt_address_street_2: requestData?.al22 || '',
  alt_address_city: requestData?.town2 || '',
  alt_address_state: requestData?.county2 || '',
  network_name_c: requestData?.mon === 'Other' ? requestData.monOther : requestData?.mon || '',
  Title: requestData?.jobTitle || '',
  Mobile: requestData?.mobileNo || '',
  email_case_updates_c: requestData?.caseUpdates || '',
  email_commission_c: requestData?.commStat || '',
  email_marketing_c: requestData?.marketing || '',
  member_club_c: requestData?.club === 'Other' ? requestData.clubOther : requestData.club || '',
  directly_authorized_c: requestData?.authorised === '1' ? 'Yes' : 'No',
  bank_account_name_c: requestData?.account || '',
  account_number_c: requestData?.accountNumber || '',
  sort_code_c: requestData?.sortCode || '',
  LeadSource: requestData?.authorised === '1' ? 'Yes' : 'No' || '',
  Broker_Registration_Signature__c: requestData?.signature || '',
  broker_registration_c: 'Yes',
  cpd21_status_c: cpd21Result?.status || '',
  hear: requestData?.hear || '',
  hear_other: requestData?.hearOther || '',
  council_member_c: requestData?.councilMember === '1' ? 'Yes' : 'No',
});

export const transformToNotificationData = (requestData) => ({
  'first-name': requestData.firstName,
  'last-name': requestData.lastName,
  'email': requestData.email,
  'fca-id': requestData.fcaId,
  'company-status': requestData.companyStatus,
  'name': requestData.name,
  'phone': requestData.phone,
  'postcode': requestData.postcode,
  'al1': requestData.al1,
  'al2': requestData.al2,
  'town': requestData.town,
  'county': requestData.county,
  'FcaData': requestData?.fcaData,
  'name2': requestData.name2,
  'phone2': requestData.phone2,
  'postcode2': requestData.postcode2,
  'al12': requestData.al12,
  'al22': requestData.al22,
  'town2': requestData.town2,
  'county2': requestData.county2,
  'mon-input': requestData.mon,
  'mon-other': requestData.monOther,
  'job-title': requestData.jobTitle,
  'mobile-no': requestData.mobileNo,
  'case-updates': requestData.caseUpdates,
  'comm-stat': requestData.commStat,
  'marketing': requestData.marketing,
  'club': requestData.club,
  'club-other': requestData.clubOther,
  'authorised': requestData?.authorised,
  'account': requestData.account,
  'Account-number': requestData.accountNumber,
  'Sort-code': requestData.sortCode,
  'hear': requestData.hear,
  'hear-other': requestData.hearOther,
  'signature': requestData.signature,
});

const postWithCsrf = async (url, body, headers = {}) => {
  const csrfToken = await fetchCSRFToken();

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
      ...headers,
    },
    body: JSON.stringify(body),
  });
};

export class RegistrationApiService {
  /**
   * Submit a completed registration. The server validates it, runs the CPD21
   * lookup, posts to SugarCRM and sends the emails and notification.
   */
  static async submitRegistration(requestData, turnstileToken) {
    const response = await postWithCsrf('/api/registration', requestData, {
      'cf-turnstile-response': turnstileToken,
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: Registration failed`);
    }

    return await response.json();
  }

  static async sendAbandonedNotification({ firstName, lastName, email, privacyAgreed }) {
    const response = await postWithCsrf('/api/registration/abandoned', {
      firstName,
      lastName,
      email,
      privacyAgreed,
    });

    if (!response.ok) {
      console.error('Error sending registration notification');
      return { success: false };
    }

    return await response.json();
  }
}
